import { render, staticRenderFns } from "./BotSettings.vue?vue&type=template&id=8b2794e6"
import script from "./BotSettings.vue?vue&type=script&lang=ts"
export * from "./BotSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports